<template>
  <div class="swiper_list container-build">
    <div class="swiper-container banner">
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in swiper_list"
          :key="item.id"
          :data-index="index"
          @click="golink(item.linkUrl, item.actiontype)"
        >
          <div class="swiper-item swiper">
            <img :src="item.pc_imgUrl" class="hidden-xs" />
            <img :src="item.imgUrl" class="hidden-lg hidden-md hidden-sm " />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <!-- 如果需要滚动条 -->
      <!--    <div class="swiper-scrollbar"></div>-->
    </div>
  </div>
</template>

<script>
let BannerSwiper;
import Swiper from "swiper";
export default {
  //props: ["swiper_list"],
  props: {
    swiper_list: {
      type: Array,
      default() {
        return;
      }
    },
    //数量
    swiper_num: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    console.log(this.$props.swiper_num);
  },
  methods: {
    // golink(e) {
    //   console.log(e);
    //   var list = this.swiper_list;
    //   var index = e.currentTarget.dataset.index;
    //   var item = list[index];
    //   switch (item.actiontype) {
    //     case "schemes":
    //       let _this = this;
    //       var tempArr = item.schemes.split("|");
    //       // 判断平台
    //       if (plus.os.name == "Android") {
    //         plus.runtime.launchApplication(
    //           {
    //             pname: tempArr[0]
    //           },
    //           function(e) {
    //             console.log("Open system default browser failed: " + e.message);
    //           }
    //         );
    //       } else if (plus.os.name == "iOS") {
    //         plus.runtime.launchApplication(
    //           {
    //             action: tempArr[1]
    //           },
    //           function(e) {
    //             console.log("Open system default browser failed: " + e.message);
    //           }
    //         );
    //       }
    //       break;
    //     case "openbrowser":
    //       plus.runtime.openURL(item.linkUrl);
    //       break;
    //     case "news":
    //       uni.navigateTo({
    //         url: "../../pages/news-detail/news-detail?id=" + item.dId
    //       });
    //       break;
    //     case "webview":
    //       uni.navigateTo({
    //         url: "../../pages/webview/webview?url=" + item.linkUrl
    //       });
    //       break;
    //   }
    //   console.log(item);
    // }
    golink(url, actiontype) {
      if (url) {
        if (actiontype == "page") {
          window.open(url, "_self");
        } else {
          window.open(url, "_blank");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.swiper_list {
  width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0;
  @media (max-width: 991px) {
    border-radius: 0.12rem;
  }
  .swiper {
    width: 100%;
    height: auto;
    border-radius: 0;
    @media (max-width: 991px) {
      border-radius: 0.12rem;
    }

    img {
      width: 100%;
      border-radius: 0;
      height: auto;
      @media (max-width: 991px) {
        border-radius: 0.12rem;
        height: 2.6rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/indexswiper.vue